/* iPhone/iOS Safari: lock page scroll behind any open modal dialog or drawer.
   iOS ignores overflow:hidden on <html>/<body>, so the page (and the dynamic toolbar) moved under overlays.
   Pins <body> at the saved offset while an overlay is open and restores it on close. Skips if something else already pinned the body. */
(function(){
  var html=document.documentElement,state=null;
  function active(){
    var b=document.body;if(!b)return false;
    if(/(^|\s)overflow-hidden/.test(b.className))return true;
    var ds=document.querySelectorAll('dialog[open]');
    for(var i=0;i<ds.length;i++){try{if(ds[i].matches(':modal'))return true;}catch(e){return true;}}
    return false;
  }
  function lock(){var b=document.body;if(state||b.style.position==='fixed')return;state={y:window.scrollY||html.scrollTop||0,css:b.style.cssText};b.style.position='fixed';b.style.top=(-state.y)+'px';b.style.left='0';b.style.right='0';b.style.width='100%';}
  function unlock(){if(!state)return;var b=document.body,y=state.y,sb=html.style.scrollBehavior;b.style.cssText=state.css;state=null;html.style.scrollBehavior='auto';window.scrollTo(0,y);html.style.scrollBehavior=sb;}
  var queued=false;
  function check(){queued=false;if(active())lock();else unlock();}
  function start(){new MutationObserver(function(){if(!queued){queued=true;requestAnimationFrame(check);}}).observe(html,{subtree:true,attributes:true,attributeFilter:['open','class']});document.addEventListener('close',function(){requestAnimationFrame(check);},true);}
  if(document.body)start();else document.addEventListener('DOMContentLoaded',start);
})();
